import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiBaseURL } from '../system/Constants/API.js';

const initialState = {
  pos: {
    IsOrderSaved: false,
    selectedCustomer: {
      balance: {
        $numberDecimal: Number(0)
      }
    },
    selectedBranch: {},
    selectedUser: {},
    products: [],
    orderExist: false,
    orderSubmitted: false,
    orderId: '',
    orderNumber: '',
    vat: true,
    stockTransfer: false,
    lineItems: [],
    orderTotals: {
      productCount: Number(0),
      productQuantity: Number(0),
      productExc: Number(0),
      productvat: Number(0),
      productTotal: Number(0)
    },
    orderDetails: {},
    payment: {
      prevCustomerBalance: Number(0),
      orderTotalPrice: Number(0),
      cash: Number(0),
      eft: Number(0),
      totalPaid: Number(0),
      allocateToAccount: Number(0),
      newCustomerBalance: Number(0)
    },
    locked: false,
    orderstatus: 'pending'
  }
};

/**
 * Submit Order
 * Dispatch Function
 * @param {object} - order payload
 * @return {object} - success payload
 */
export const submitOrder = createAsyncThunk(
  'pos/PostOrder',
  async (payload, thunkAPI) => {
    const { orderType, orderPayLoad } = payload;
    console.log('pos/PostOrder', orderPayLoad);
    try {
      const response = await axios.post(
        `${apiBaseURL}/api/v1/${orderType}/`,
        orderPayLoad
      );
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/**
 * Submit Payment
 * Dispatch Function
 * @param {object} - payment
 * @return {object} - success payload
 */
export const submitPayment = createAsyncThunk(
  'pos/PostPayment',
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        `${apiBaseURL}/api/v1/transactions/payment/paid`,
        payload
      );
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

/**
 * Edit Order
 * Dispatch Function
 * @param {object} - payload
 * @return {object} - success payload
 */
export const setPosStateEditOrder = createAsyncThunk(
  'pos/setPosStateEditOrder',
  async (payload, thunkAPI) => {
    const { orderType, po_id } = payload;
    console.log('pos/setPosStateEditOrder - payload : ', payload);
    try {
      const response = await axios.get(
        `${apiBaseURL}/api/v1/${orderType}/${po_id}/`
      );
      console.log('pos/setPosStateEditOrder', response);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

//TODO: !IMPORTANT - What does it effect???
//dispatch(slice.actions.clearOrderData(initialState))

export const receivePayment = createAsyncThunk(
  'pos/PostReceivePayment',
  async (payload, thunkAPI) => {
    try {
      const response = await axios.post(
        `${apiBaseURL}/api/v1/transactions/payment/received`,
        payload
      );
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const slice = createSlice({
  name: 'pos',
  initialState,
  reducers: {
    // getSelectedCustomer(state, action) {
    //   const { branches } = action.payload;
    //   // state.branches = branches;
    // },
    setSelectedBranch(state, action) {
      state.pos.selectedBranch = action.payload;
    },
    setSelectedUser(state, action) {
      state.pos.selectedUser = action.payload;
    },
    createOrderExist(state, action) {
      state.pos.orderExist = action.payload;
    },
    createOrderId(state, action) {
      state.pos.orderId = action.payload;
    },
    createOrderNumber(state, action) {
      state.pos.orderNumber = action.payload;
    },
    setSelectedCustomer(state, action) {
      state.pos.selectedCustomer = action.payload;
    },
    setSelectedVehRegNum(state, action) {
      state.pos.selectedVehRegNum = action.payload;
    },
    setOrderNoteState(state, action) {
      state.pos.orderNote = action.payload;
    },
    setVat(state, action) {
      state.pos.vat = action.payload;
    },
    setStockTransfer(state, action) {
      state.pos.stockTransfer = action.payload;
    },
    setLineItem(state, action) {
      state.pos.lineItems = [...state.pos.lineItems, action.payload];
    },
    updateLineItem(state, action) {
      // get the id of the item that was updated
      const id = action.payload.id;
      // get the index of the item in the array
      const index = state.pos.lineItems.findIndex(
        item => item.productId === action.payload.productId
      );
      // update the selected item
      state.pos.lineItems[index] = action.payload;
    },
    removeLineItem(state, action) {
      // new items state, exlude the removed item.
      state.pos.lineItems = state.pos.lineItems.filter(
        item => item.productId !== action.payload.productId
      );
    },
    setLineItemTotals(state, action) {
      state.pos.orderTotals = action.payload;
    },
    setPaymentDetails(state, action) {
      state.pos.payment = action.payload;
    },
    // orderSubmitted(state, action) {
    //   state.pos.orderSubmitted = action.payload;
    // },
    setPosOrderStateForPayment(state, action) {
      state.pos = action.payload;
    },
    // setPosStateEditOrder(state, action) {
    //   state.pos = action.payload;
    // },
    setIsOrderSaved(state, action) {
      state.pos.IsOrderSaved = action.payload;
    },
    clearOrderData(state, action) {
      return initialState;
    }
  },
  extraReducers: {
    [setPosStateEditOrder.pending]: (state, action) => {
      state.pos.orderEditstatus = 'loading';
    },
    [setPosStateEditOrder.fulfilled]: (state, action) => {
      const orderType = action.meta.arg.orderType;
      const userId = action.meta.arg.user;
      const orderData = action.payload.data.orderData;

      let orderNumber;
      switch (orderType) {
        case 'sales':
          orderNumber = orderData.SONumber;
          break;

        case 'purchases':
          orderNumber = orderData.PONumber;
          break;

        default:
          break;
      }

      const posEdit = {
        locked: orderData.locked,
        selectedCustomer: orderData.customer,
        selectedBranch: {
          _id: orderData.branch,
          branchId: orderData.branch
        },
        selectedUser: {
          _id: orderData.user
        },
        products: [],
        orderExist: true,
        orderSubmitted: true,
        orderId: orderData._id,
        orderNumber,
        notes: orderData.notes,
        selectedVehRegNum: orderData.selectedVehRegNum ? orderData.selectedVehRegNum : '',
        vat: orderData.vat ? orderData.vat : true,
        lineItems: orderData.lineItems,
        orderTotals: {
          productCount:
            orderData.orderTotal && orderData.orderTotal.totalProducts
              ? Number(orderData.orderTotal.totalProducts.$numberDecimal)
              : 0,
          productQuantity:
            orderData.orderTotal && orderData.orderTotal.totalnett
              ? Number(orderData.orderTotal.totalnett.$numberDecimal)
              : 0,
          productExc:
            orderData.orderTotal && orderData.orderTotal.totalSub
              ? Number(orderData.orderTotal.totalSub.$numberDecimal)
              : 0,
          productVat:
            orderData.orderTotal && orderData.orderTotal.totalVat
              ? Number(orderData.orderTotal.totalVat.$numberDecimal)
              : 0,
          productTotal:
            orderData.orderTotal && orderData.orderTotal.totalInc
              ? Number(orderData.orderTotal.totalInc.$numberDecimal)
              : 0
        },
        payment: {
          prevCustomerBalance: Number(0),
          orderTotalPrice: Number(0),
          cash: Number(0),
          eft: Number(0),
          totalPaid: Number(0),
          allocateToAccount: Number(0),
          newCustomerBalance: Number(0)
        }
      };

      state.pos = posEdit;
      state.pos.orderEditstatus = 'saved';
    },
    [setPosStateEditOrder.rejected]: (state, action) => {
      state.pos.orderEditstatus = 'failed';
    },
    [submitOrder.pending]: (state, action) => {
      state.pos.orderstatus = 'loading';
    },
    [submitOrder.fulfilled]: (state, action) => {
      state.pos.orderstatus = 'saved';
    },
    [submitOrder.rejected]: (state, action) => {
      state.pos.orderstatus = 'failed';
    },
    [submitPayment.pending]: (state, action) => {
      state.pos.paymentStatus = 'loading';
    },
    [submitPayment.fulfilled]: (state, action) => {
      state.pos.paymentStatus = 'success';
    },
    [submitPayment.rejected]: (state, action) => {
      state.pos.paymentStatus = 'failed';
    },
    [receivePayment.pending]: (state, action) => {
      state.pos.paymentStatus = 'loading';
    },
    [receivePayment.fulfilled]: (state, action) => {
      state.pos.paymentStatus = 'success';
    },
    [receivePayment.rejected]: (state, action) => {
      state.pos.paymentStatus = 'failed';
    }
  }
});

//  // Add reducers for additional action types here, and handle loading state as needed
//  builder.addCase(submitOrder.fulfilled , (state, action) => {
//   // Add user to the state array
//   state.pos.orderSubmitted.push(action.payload);
// })
// },

export const reducer = slice.reducer;

export const setIsOrderSaved = orderSubStatus => async dispatch => {
  dispatch(slice.actions.setIsOrderSaved(orderSubStatus));
};

export const setSelectedVehRegNum = vehRegNum => async dispatch => {
  dispatch(slice.actions.setSelectedVehRegNum(vehRegNum));
};

export const setSelectedCustomer = customer => async dispatch => {
  //if (process.env.REACT_APP_DEVELOPMENT_ENV)
  //console.log('[POS - SLICE] : (setSelectedCustomer)', customer);
  dispatch(slice.actions.setSelectedCustomer(customer));
};

export const setOrderNoteState = orderNote => async dispatch => {
  dispatch(slice.actions.setOrderNoteState(orderNote));
};

export const setVat = vat => async dispatch => {
  dispatch(slice.actions.setVat(vat));
};

export const setStockTransfer = stockTransfer => async dispatch => {
  dispatch(slice.actions.setStockTransfer(stockTransfer));
};

// Add Remove Products Dialog
export const setLineItem = lineItem => async dispatch => {
  dispatch(slice.actions.setLineItem(lineItem));
};

export const updateLineItem = lineItem => async dispatch => {
  dispatch(slice.actions.updateLineItem(lineItem));
};

export const removeLineItem = lineItem => async dispatch => {
  dispatch(slice.actions.removeLineItem(lineItem));
};

export const setLineItemTotals = lineItemsTotals => async dispatch => {
  dispatch(slice.actions.setLineItemTotals(lineItemsTotals));
};

export const setSelectedUser = payload => async dispatch => {
  dispatch(slice.actions.setSelectedUser(payload));
};

export const setSelectedBranch = payload => async dispatch => {
  dispatch(slice.actions.setSelectedBranch(payload));
};

// Create Order
export const createOrder = (orderType, payload) => async dispatch => {
  console.log('createOrder - payload', payload);
  let response = {};
  try {
    response = await axios.post(
      `${apiBaseURL}/api/v1/${orderType}/new`,
      payload
    );
  } catch (error) {
    console.error(error);
  }

  console.log('[createOrder] - response', response);

  //now we run the dispatch stages
  if (response.data.orderNumber && response.data.orderExist) {
    if (response.data.orderExist === true) {
      dispatch(slice.actions.createOrderNumber(response.data.orderNumber));
      dispatch(slice.actions.createOrderId(response.data.orderDoc._id));
      dispatch(slice.actions.createOrderExist(response.data.orderExist));
    }
  }
};

export const setPaymentDetails = payload => async dispatch => {
  dispatch(slice.actions.setPaymentDetails(payload));
};

export const clearOrderData = () => async dispatch => {
  dispatch(slice.actions.clearOrderData(initialState));
};

// export const receivePayment = (payload) => async dispatch => {
//   let response;
//   try {
//     response = await axios.post(`${apiBaseURL}/api/v1/transactions/payment/received`, payload);
//   } catch (error) {
//     console.error(error);
//   }
// }

export const confirmEft = payload => async dispatch => {
  //console.log('[slice: POS] (confirmEft) - payload', payload);

  let response;
  try {
    response = await axios.post(
      `${apiBaseURL}/api/v1/transactions/eft/paid`,
      payload
    );
  } catch (error) {
    console.error(error);
  }

  //console.log('[slice: POS] (confirmEft) - response', response);
};

export const confirmEftReceived = payload => async dispatch => {
  //console.log('[slice: POS] (confirmEft) - payload', payload);

  let response;
  try {
    response = await axios.post(
      `${apiBaseURL}/api/v1/transactions/eft/received`,
      payload
    );
  } catch (error) {
    console.error(error);
  }

  //console.log('[slice: POS] (confirmEft) - response', response);
};

export const setPosOrderStateForPayment = (
  orderType,
  payload
) => async dispatch => {
  //console.log('[slice: POS] (setPosOrderStateForPayment) - payload', payload);

  const { po_id, user } = payload;

  let response;
  try {
    response = await axios.get(
      `${apiBaseURL}/api/v1/${orderType}/${po_id}/`,
      payload
    );
  } catch (error) {
    console.error(error);
  }

  // console.log('[slice: POS] (setPosOrderStateForPayment) - response', response);

  const orderData = response.data.orderData;

  //console.log('[slice: POS] (setPosOrderStateForPayment) - purchaseOrder', purchaseOrder);

  let orderNumber;
  switch (orderType) {
    case 'sales':
      orderNumber = orderData.SONumber;
      break;

    case 'purchases':
      orderNumber = orderData.PONumber;
      break;

    default:
      break;
  }

  const pos = {
    selectedCustomer: {
      balance: {
        $numberDecimal:
          orderData.customer.balance &&
          orderData.customer.balance.$numberDecimal
            ? Number(orderData.customer.balance.$numberDecimal)
            : 0
      },
      id: orderData.customer.id,
      _id: orderData.customer._id
    },
    selectedBranch: {},
    selectedUser: {
      _id: user._id
    },
    products: [],
    orderExist: true,
    orderSubmitted: true,
    orderId: orderData._id,
    orderNumber,
    vat: orderData.vat,
    lineItems: [],
    orderTotals: {
      productTotal: Number(orderData.orderTotal.totalInc.$numberDecimal)
    },
    payment: {
      prevCustomerBalance: Number(0),
      orderTotalPrice: Number(0),
      cash: Number(0),
      eft: Number(0),
      totalPaid: Number(0),
      allocateToAccount: Number(0),
      newCustomerBalance: Number(0)
    }
  };

  //console.log('[slice: POS] (setPosOrderStateForPayment) - pos', pos);

  dispatch(slice.actions.setPosOrderStateForPayment(pos));
};

// export const setPosStateEditOrder = (orderType, payload) => async dispatch => {

//   const { po_id, user } = payload;

//   let response;
//   try {
//     response = await axios.get(`${apiBaseURL}/api/v1/${orderType}/${po_id}/`);
//   } catch (error) {
//     console.error(error);
//   }

//   const orderData = response.data.orderData;

//   let orderNumber;
//   switch (orderType) {
//     case 'sales':
//       orderNumber = orderData.SONumber;
//       break;

//     case 'purchases':
//       orderNumber = orderData.PONumber;
//     break;

//     default:
//       break;
//   }

//   const posEdit = {
//     locked: orderData.locked,
//     selectedCustomer: orderData.customer,
//     selectedBranch: {
//       _id: orderData.branchId,
//       branchId: orderData.branchId,
//     },
//     selectedUser: {
//       _id: user._id,
//     },
//     products: [],
//     orderExist: true,
//     orderSubmitted: true,
//     orderId: orderData._id,
//     orderNumber,
//     notes: orderData.notes,
//     selectedVehRegNum: orderData.selectedVehRegNum,
//     vat: (orderData.vat) ? orderData.vat : true,
//     lineItems: orderData.lineItems,
//     orderTotals: {
//       productCount: (orderData.orderTotal && orderData.orderTotal.totalProducts) ? Number(orderData.orderTotal.totalProducts.$numberDecimal) : 0,
//       productQuantity: (orderData.orderTotal && orderData.orderTotal.totalnett) ? Number(orderData.orderTotal.totalnett.$numberDecimal) : 0,
//       productExc: (orderData.orderTotal && orderData.orderTotal.totalSub) ? Number(orderData.orderTotal.totalSub.$numberDecimal) : 0,
//       productVat: (orderData.orderTotal && orderData.orderTotal.totalVat) ? Number(orderData.orderTotal.totalVat.$numberDecimal) : 0,
//       productTotal: (orderData.orderTotal && orderData.orderTotal.totalInc) ? Number(orderData.orderTotal.totalInc.$numberDecimal): 0,
//       },
//     payment: {
//       prevCustomerBalance: Number(0),
//       orderTotalPrice: Number(0),
//       cash: Number(0),
//       eft: Number(0),
//       totalPaid: Number(0),
//       allocateToAccount: Number(0),
//       newCustomerBalance: Number(0),
//     }
//   }

//   //console.log('[slice: POS] (setPosStateEditOrder) - pos object', posEdit);
//   if (response.status === 200) {
//     dispatch(slice.actions.setPosStateEditOrder(posEdit));
//   }
// }

export default slice;
